
import React, { useState, useEffect, useRef } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import Datepicker from "react-tailwindcss-datepicker";
import { useNavigate } from "react-router";

import {
  SlSelect,
  SlOption,
  SlIcon,
  SlDrawer,
  SlButton
} from "@shoelace-style/shoelace/dist/react";
import { Toast } from "../../shared/Toast";
import { CSVLink } from "react-csv";
import Paginator from "../../shared/Paginator";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { toLakhs, languageOptions, stateOptions, pricePackages, packageNewOldOptions, LocalPricePackages,BrandsTypes, slotPaymentTypeOptions, formatSpentValue } from "../../utils/constants";
import Select from 'react-select';
import api from "../../services/api";
import { formatDateDDMMYYY } from "../../utils/dateFormat";
import TableSkelton from "../../shared/TableSkelton";
import config from "../../config";
import { orderPaymentTypes } from "../../utils/constants";
import { clampCurrentMonthDateRange, getCurrentReportMonthDateRange } from "./reportDateUtils";
import PdfViewer from "../Orders/PdfViewer";

const TABLE_COLSPAN = 22;

const FinanceReport = ()=>{
    const currentReportMonthDateRange = getCurrentReportMonthDateRange();
    const navigate = useNavigate();
  
    const [financedata, setfinancedata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalcount, settotalcount] = useState(0);
    const [brandtypes, setbrandtypes] = useState([5]); //alpha
    const [downloader, setDownloader] = useState(false);
    const [salesList, setsalesList] = useState([]);
    const [salesId, setsalesId] = useState(null);
    const [weeks, setweeks] = useState(null);
    const [order_new_old, setorder_new_old] = useState(null);
    const csvLinkRef = useRef();
    const pendingDownloadRef = useRef(false);
    const [dateRange, setDateRange] = useState(currentReportMonthDateRange);
    const [langfilter, setLangFilter] = useState("1");
    const [statefilter, setStatefilter] = useState(-1);
    const [districtselect, setSelectdistrict] = useState([]);
    const [districtfilter, setDistrictfilter] = useState([]);
    const [internalDetails, setInternalDetails] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [target_filter, setTarget_filter] = useState({
      lang_id: "1",
      state_id: -1,
      district_id: [],
    });
    const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false);
    const [selectedOrder, setselectedOrder] = useState([]);
    const [downloadedData, setDownloadedData] = useState([]);
    const [salesLocations,setSalesLocations] = useState([])
    const [selectedSalesLocation, setSelectedSalesLocation] = useState(null);
    const [isPackage, setIsPackage] = useState(null);
    const [isAgency, setIsAgency] = useState(null);
    const [viewPdf, setViewPdf] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const formatAgency = (row) => {
      const val = row?.isagency ?? row?.agency;
      if (val === 1 || val === true || val === "1") return "TRUE";
      if (val === 0 || val === false || val === "0") return "FALSE";
      return "-";
    };

    const getRoFileUrl = (row) => row?.rofile_url || row?.ro_file || "";

    const getOrderValueWithGst = (orderValue) => Number(orderValue || 0) * 1.18;

    const getPendingAmount = (row) => {
      const pending = getOrderValueWithGst(row?.order_value) - Number(row?.total_paid || 0);
      return pending > 0 ? +(pending.toFixed(2)) : 0;
    };

    const downloadPdf = async (url, fileName) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const fileType = url.split(".").pop();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${fileName}_ro.${fileType}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        Toast("error", "Error downloading PDF");
        console.error("Error downloading PDF:", error);
      }
    };

    const viewPayments = (orderdetails) => {
      setselectedOrder(orderdetails || []);
      setOpenPaymentDrawer(true);
    };
    const fields = [
      { key: 'payment_type', label: 'Payment Type' },
      { key: 'amount', label: 'Amount' },
      { key: 'link_id', label: 'Link ID/Transaction_id'},
      { key: 'cf_link_id', label: 'Cashfree Link ID', showWhen: (payment) => +payment?.payment_type === 1},
      { key: 'pan_no', label: 'PAN No', showWhen: (payment) => +payment?.payment_type === 3},
    ];

const handlePaymentRequestClose = () => setOpenPaymentDrawer(false);
const handlePaymentAfterHide = () => setselectedOrder([]);

    const Headers = [
      { label: "S.No", key: "sno" },
      { label: "Month", key: "month" },
      { label: "Year", key: "year" },
      { label: "Target", key: "target" },
      { label: "Sales POC Location", key: "sales_poc_location" },
      { label: "OrderId", key: "order_id" },
      { label: "OrderName", key: "order_name" },
      { label: "Company Name", key: "company_name" },
      { label: "Sales Person", key: "sales_person" },
      { label: "Brands", key: "brands" },
      { label: "New/Old",key:"isnew"},
      { label: "Package", key: "package" },
      { label: "Agency", key: "agency" },
      { label: "RO File", key: "ro_file" },
      { label: "Start Date", key: "start_date" },
      { label: "Order Value", key: "order_value" },
      { label: "Including GST Order Value", key:"order_value_including_gst"},
      { label: "Recieved Amount", key: "received_amount" },
      { label: "Pending Amount", key: "pending_amount" },
      { label: "Filter Spent", key: "filter_spent" },
      { label: "Total Spent", key: "total_spent" },
      { label: "Payment Details", key: "payment_details" },
      { label: "Image URLs", key: "img_urls" },
      { label: "Video URLs", key: "video" },
    ];
    const downloadPackageAdReport = async () => {
      setDownloader(true);
      pendingDownloadRef.current = true;
      const data = await downFinanceReport();
      if (!data || data.length === 0) {
        pendingDownloadRef.current = false;
        setDownloader(false);
        Toast("error", "No data to Download");
        return;
      }
    }
    const getLanguageLabel = (lang_id) => {
      const language = languageOptions.find(lang => lang.value === lang_id);
      return language ? language.label : "Unknown Language"; // Default to "Unknown Language" if not found
    };
    const defaultValue = (options, selectedValues) => {
        if (Array.isArray(selectedValues)) {
          return options?.filter(option => selectedValues.includes(option?.value));
        } else {
          return options?.find(option => option.value === selectedValues) || null;
        }
    };
    const handleDateRange = (selectedDate) => {
        if (selectedDate) {
          if (selectedDate.startDate && selectedDate.endDate) {
            setDateRange(clampCurrentMonthDateRange(selectedDate));
          } else {
            setDateRange({ startDate: null, endDate: null });
          }
        } else {
          setDateRange({ startDate: null, endDate: null });
        }
    }
    const LanguageFilterChange = (e) => {
        setLangFilter(e.target.value);
        setDistrictfilter([]);
        setTarget_filter({
          lang_id: e.target.value,
          state_id: -1,
          district_id: -1,
          mandal_id: -1,
          village_id: -1,
        });
        if (parseInt(e.target.value) === -1) {
          setStatefilter(-1);
          setLangFilter(-1);
          setSelectdistrict([]);
        }
    };
    
    const StateFilterChange = async (value) => {
        setStatefilter(value);
        if (parseInt(value) !== -1) {
          try {
            let res = await api({
              url: "/location/getDistrictsByStateId",
              method: "POST",
              responseType: "json",
              data: { states: [value], langs: [langfilter] },
            });
            let districts = [];
            for await (let item of res.data) {
              const temp = { value: item, label: `${item.dist_name}` };
              districts.push(temp);
            }
            setDistrictfilter(districts);
          } catch (error) {
            console.error(error);
            if (error.response.status === 401) navigate("/");
          }
        }
        if (parseInt(value) === -1) {
          setSelectdistrict([]);
          setStatefilter(-1);
        }
    };

    const DistrictFilterChanger = async (selectedOptions) => {
        if (selectedOptions && selectedOptions.length > 0) {
          const values = selectedOptions.map(option => option.value);
          setSelectdistrict(values);
        } else {
          setSelectdistrict([]);
        }
    };
    const viewInternalDetails = async(order_id) => {
        try {
          if(internalDetails && internalDetails.order_id === order_id) {
            setInternalDetails(null);
            return;
          }
          const result = await api({
            url: "/reports/packageAdReportInternalDetails",
            method: "POST",
            responseType: "json",
            data: {
              order_id: order_id
            }
          });
          if (result.code === 200) {
            setInternalDetails({order_id, list: result.data || []});
          }
        } catch (error) {
          console.error(error);
        }
    };
    const getSales = async (department_id =[]) => {
        try {
          let res = await api({
            url: "/user/sales_persons/getSalesByDepartment",
            method: "POST",
            responseType: "json",
            data: {
              dept:department_id,
            },
          });
          setsalesList(res.data);
        } catch (error) {
          console.error(error);
        }
    };
    const handleAdTypeChange = async(selectedOptions) => {
        if (!selectedOptions || selectedOptions.length === 0) {
          setbrandtypes([]);
          setsalesId(null);
          return;
        }
        const selectedDepts = selectedOptions.map(option => option.value);
        
        setbrandtypes(selectedDepts);
        setsalesId(null);
    };
    const handlePageChange = (event) => {
      const newPage = event.selected;
      setCurrentPage(newPage);
      fetchFinanceReport(newPage);
    };
    const fetchFinanceReport = async (page = 0) => {
        setLoading(true)
        try {
          let res = await api({
            url: `/reports/fetchFinanceReport`,
            method: "POST",
            responseType: "json",
            data: {
              newusertypes:brandtypes,
              salesId,
              startTimestamp: dateRange.startDate,
              endTimestamp: dateRange.endDate,
              lang_id: +langfilter === -1 ? null : +langfilter,
              state_id: +statefilter === -1 ? null : +statefilter,
              district_ids: districtselect.length > 0 ? districtselect : [],
              order_new_old: order_new_old,
              search:search,
              sales_location: selectedSalesLocation?.value || null,
              is_package: isPackage?.value ?? null,
              isagency: isAgency?.value ?? null,
              page:page,
              limit: config.PER_PAGE,
            }
          })
          if (res.code == 200)
            setfinancedata(res.data?.data || []);
            settotalcount(res.data?.total_count || 0);
    
        } catch (err) {
          console.log(err);
        }
        finally{
          setLoading(false)
        }
    }
    const downFinanceReport = async () => {
      try {
        let res = await api({
          url: `/reports/fetchFinanceReport`,
          method: "POST",
          responseType: "json",
          data: {
            newusertypes:brandtypes,
            salesId,
            startTimestamp: dateRange.startDate,
            endTimestamp: dateRange.endDate,
            lang_id: +langfilter === -1 ? null : +langfilter,
            state_id: +statefilter === -1 ? null : +statefilter,
            district_ids: districtselect.length > 0 ? districtselect : [],
            order_new_old: order_new_old,
            search:search,
            sales_location: selectedSalesLocation?.value || null,
            is_package: isPackage?.value ?? null,
            isagency: isAgency?.value ?? null,
            needPagination:false
          }
        })
        if (res.code == 200)
        {
          setDownloadedData(res.data?.data || [])
          return res.data?.data || []
        }
        return []
  
      } catch (err) {
        console.log(err);
        return []
      }
      finally{
        setLoading(false)
      }
  }
  useEffect(()=>{
    const getSalesLocations = async()=>{
       const result = await api({
         url : '/reports/getlocationsDownloadReports',
       })
       if(result.code === 200){
         setSalesLocations(result.data || [])
       }
    }
     getSalesLocations();
  },[])
    const searchData = (e) => {
      setSearch(e.target.value);
    };
    useEffect(() => {
        if(brandtypes)
        getSales(brandtypes);
    }, [brandtypes]);
    useEffect(() => {
        fetchFinanceReport();
      }, [brandtypes, salesId, dateRange, langfilter, statefilter, districtselect, order_new_old, search, selectedSalesLocation, isPackage, isAgency])

    useEffect(() => {
      if (!pendingDownloadRef.current || !downloadedData.length) return;
      csvLinkRef?.current?.link?.click();
      pendingDownloadRef.current = false;
      setTimeout(() => {
        setDownloader(false);
      }, 3000);
    }, [downloadedData]);

    return(
        <div className="p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-4 items-end">
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Search Order</label>
              <input
                type="text"
                id="myInput"
                placeholder="Order Name..."
                className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none h-[38px]"
                onChange={(e) => searchData(e)}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Brand Type</label>
              <Select
                options={BrandsTypes}
                value={BrandsTypes.filter(option => brandtypes.includes(option.value))}
                onChange={handleAdTypeChange}
                isClearable
                isMulti
                placeholder="Select Ad Type"
                classNamePrefix="react-select"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Sales Persons</label>
              <Select
                aria-label="Default select example"
                placeholder="Sales Person"
                value={defaultValue(salesList, salesId)}
                onChange={(selected) => {
                  if (!selected || selected.length === 0) {
                    setsalesId(null);
                  } else {
                    setsalesId(selected.map((item) => item.value));
                  }
                }}
                options={salesList}
                isMulti
                isClearable
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">New/Old</label>
              <Select
                aria-label="Default select example"
                placeholder="New/Old"
                value={defaultValue(packageNewOldOptions, order_new_old)}
                onChange={(selected) => {
                  setorder_new_old(selected ? selected.value : null);
                }}
                options={packageNewOldOptions}
                isClearable
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Sales Location</label>
              <Select
                aria-label="Default select example"
                placeholder="Sales Location"
                value={selectedSalesLocation}
                onChange={(selected) => setSelectedSalesLocation(selected)}
                options={salesLocations.map(loc => ({ value: loc.id, label: loc.name + (loc?.region_id ===-1 ? ' (region)' : ' (location)') }))}
                isClearable
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Package</label>
              <Select
                aria-label="Default select example"
                placeholder="Package"
                value={isPackage}
                onChange={(selected) => setIsPackage(selected)}
                options={[{ value: 1, label: "True" }, { value: 0, label: "False" }]}
                isClearable
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Agency</label>
              <Select
                aria-label="Agency filter"
                placeholder="Agency"
                value={isAgency}
                onChange={(selected) => setIsAgency(selected)}
                options={[{ value: 1, label: "True" }, { value: 0, label: "False" }]}
                isClearable
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Date Range</label>
              <div className="border border-gray-300 rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 transition-all">
                <Datepicker
                  classNames="form-input"
                  value={dateRange}
                  primaryColor={"cyan"}
                  showShortcuts={true}
                  useRange={true}
                  configs={{
                    shortcuts: {
                      today: "today",
                      yesterday: "yesterday",
                      currentMonth: "currentMonth",
                      pastMonth: "lastMonth",
                    },
                  }}
                  onChange={handleDateRange}
                />
              </div>
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Language</label>
              <SlSelect
                placeholder="Select Language"
                name="lang"
                size="medium"
                onSlChange={LanguageFilterChange}
                value={langfilter}
                className="w-full"
              >
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                {languageOptions.map((item) => (
                  <SlOption key={item.value} value={item.value}>
                    {item.label}
                  </SlOption>
                ))}
              </SlSelect>
            </div>
            {langfilter !== -1 && (
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1.5 text-gray-700">State</label>
                <SlSelect
                  placeholder="Select State"
                  name="state"
                  size="medium"
                  onSlChange={(e) => StateFilterChange(e.target.value)}
                  className="w-full"
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {stateOptions
                    .filter((item) => item.lang_id === +langfilter)
                    .map((item) => (
                      <SlOption key={item.state_id} value={item.state_id}>
                        {item.state_name}
                      </SlOption>
                    ))}
                </SlSelect>
              </div>
            )}
            {statefilter !== -1 && (
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1.5 text-gray-700">District</label>
                <Select
                  placeholder="Select Districts"
                  name="district"
                  isMulti={true}
                  isClearable={true}
                  options={districtfilter.map((item) => ({
                    value: item.value.dist_id,
                    label: item.label,
                  }))}
                  onChange={DistrictFilterChanger}
                  classNamePrefix="react-select"
                />
              </div>
            )}
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1.5 text-gray-700">Download</label>
              <div className="h-[38px] flex items-center">
                {downloader ? (
                  <div className="flex items-center gap-2">
                    <sl-spinner style={{ fontSize: "1.25rem" }}></sl-spinner>
                    <span className="text-sm text-gray-500">Downloading...</span>
                  </div>
                ) : (
                  <sl-tooltip content="Download" hoist>
                    <sl-icon-button
                      library="lucide"
                      name="download"
                      onClick={() => downloadPackageAdReport()}
                    ></sl-icon-button>
                  </sl-tooltip>
                )}
              </div>
            </div>
            <CSVLink
              data={[
                ...downloadedData?.map((row, idx) => ({
                  sno: idx + 1,
                  month: new Date(row?.o_start_date * 1000).toLocaleString("default",{ month: "long" }),
                  year: new Date(row?.o_start_date * 1000).toLocaleString("default",{ year: "numeric" }),
                  target: [
                    row?.lang_ids?.length > 0 && `Languages: ${row.lang_ids.map(id => getLanguageLabel(id)).join(", ")}`,
                    row?.state_ids?.length > 0 && `States: ${row.state_ids.map(s => s.state_name).join(", ")}`,
                    row?.district_ids?.length > 0 && `Districts: ${row.district_ids.map(d => d.dist_name).join(", ")}`,
                    row?.constituency_ids?.length > 0 && `Constituencies : ${row.constituency_ids.map(c => c.const_name).join(", ")}`,
                    row?.mandal_ids?.length > 0 && `Mandals : ${row.mandal_ids.map(m => m.mandal_name).join(", ")}`,
                    row?.village_ids?.length > 0 && `Villages : ${row.village_ids.map(v => v.village).join(", ")}`
                  ].filter(Boolean).join(" \n ") || "No Location",
                  sales_poc_location: row?.sales_region_location,
                  order_id:row?.order_id,
                  order_name: row?.order_name,
                  company_name: row?.company_name || "-",
                  sales_person: row?.sales_person_name,
                  brands: row.brands?.length ? row.brands.join("\n") : "-",
                  isnew:row?.isnew ? `NEW` : `OLD`,
                  package: row?.ispackage === 1 ? "TRUE" : "FALSE",
                  agency: formatAgency(row),
                  ro_file: getRoFileUrl(row) || "-",
                  start_date: formatDateDDMMYYY(row?.o_start_date),
                  order_value: row?.order_value,
                  order_value_including_gst: getOrderValueWithGst(row?.order_value).toFixed(2),
                  received_amount: row?.total_paid,
                  pending_amount: getPendingAmount(row).toFixed(2),
                  filter_spent: Number(row?.filterSpent ?? row?.filter_spent ?? 0).toFixed(2),
                  total_spent: Number(row?.total_spent ?? 0).toFixed(2),
                  payment_details: row?.payment_details?.length
                    ? row.payment_details
                        .map(p =>
                          `{${Object.entries(p)
                            .map(([k, v]) => {
                              const finalValue =
                                k === "payment_type"
                                  ? orderPaymentTypes.find(
                                      item => +item.value === +v
                                    )?.label || v
                                  : v;

                              return `${k}: ${finalValue}`;
                            })
                            .join(", ")}}`
                        )
                        .join(" | ")
                    : "{}",
                  img_urls: row?.creatives?.map(c => c?.img_urls).filter(Boolean).join(", ") || "",
                  video: row?.creatives?.map(c => c?.video_urls).filter(Boolean).join(", ") || "",
                })),

                // -------- Grand Total Row ----------
                {
                  sno: "",
                  month: "",
                  year:"",
                  target: "",
                  order_id:"",
                  order_name: "",
                  company_name: "",
                  sales_person: "",
                  brands: "",
                  isnew:"",
                  package: "Grand Total",
                  agency: "",
                  ro_file: "",
                  start_date: "",

                  order_value: downloadedData.reduce((sum,r)=>sum + Number(r?.order_value||0),0).toFixed(2),
                  order_value_including_gst: downloadedData.reduce((sum,r)=>sum + getOrderValueWithGst(r?.order_value),0).toFixed(2),
                  received_amount: downloadedData.reduce((sum,r)=>sum + Number(r?.total_paid||0),0).toFixed(2),
                  pending_amount: downloadedData.reduce((sum,r)=>{
                    const diff = getOrderValueWithGst(r?.order_value) - Number(r?.total_paid || 0);
                    return sum + (diff > 0 ? diff : 0)
                  },0).toFixed(2),
                  filter_spent: downloadedData.reduce((sum,r)=>sum + Number(r?.filterSpent ?? r?.filter_spent ?? 0),0).toFixed(2),
                  total_spent: downloadedData.reduce((sum,r)=>sum + Number(r?.total_spent ?? 0),0).toFixed(2),
                  payment_details: "",
                  img_urls: "",
                  video: "",
                }
              ]}
              headers={Headers}
              filename="FinanceReport.csv"
              ref={csvLinkRef}
              style={{ display: "none" }}
            />
          </div>
          <ScrollContainer>
            <table className="table table-bordered mt-4">
                <thead>
                    <tr className="bg-gray-100">
                    <th>S.No</th>
                    <th>Month</th>
                    <th>Year</th>
                    <th>Target</th>
                    <th>Sales POC Location</th>
                    <th>OrderId</th>
                    <th>OrderName</th>
                    <th>Company Name</th>
                    <th>Sales Person</th>
                    <th>Brands</th>
                    <th>New/Old</th>
                    <th>Package</th>
                    <th>Agency</th>
                    <th>RO File</th>
                    <th>Start Date</th>
                    <th>Order Value</th>
                    <th>Order Value Including GST</th>
                    <th>Recieved Amount</th>
                    <th>Pending Amount</th>
                    <th>Filter Spent</th>
                    <th>Total Spent</th>
                    <th>Payment Details</th>
                    </tr>
                </thead>

                {financedata && financedata.length > 0 ? (
                    <tbody>
                    {financedata.map((row, idx) => (
                        <>
                            <tr
                                key={idx}
                                className="border-t"
                                onClick={() => {
                                    viewInternalDetails(row.order_id);
                                }}                            
                             >
                            <td>{idx + 1}</td>
                              <td>
                                {new Date(row?.o_start_date * 1000).toLocaleString(
                                    "default",
                                    { month: "long" }
                                )}
                              </td>
                              <td>
                              {new Date(row?.o_start_date * 1000).toLocaleString(
                                "default",
                                { year: "numeric" }
                              )}
                            </td>
                            <td className="max-w-[200px] truncate whitespace-nowrap overflow-hidden"
                                    title=  {[
                                        row.lang_ids?.length > 0 && `${row.lang_ids.map(id => `${getLanguageLabel(id)}(L)`).join(", ")}`,
                                        row.state_ids?.length > 0 && `${row.state_ids.map(s => `${s.state_name}(S)`).join(", ")}`,
                                        row.district_ids?.length > 0 && `${row.district_ids.map(d => `${d.dist_name}(D)`).join(", ")}`,
                                        row.constituency_ids?.length > 0 && `${row.constituency_ids.map(c => `${c.const_name}(C)`).join(", ")}`,
                                        row.mandal_ids?.length > 0 && `${row.mandal_ids.map(m => `${m.mandal_name}(M)`).join(", ")}`,
                                        row.village_ids?.length > 0 && `${row.village_ids.map(v => `${v.village}(V)`).join(", ")}`,
                                  ].filter(Boolean).join(" \n ")}
                            >
                              {row.lang_ids?.length > 0 && `${row.lang_ids.map(id => `${getLanguageLabel(id)}(L)`).join(", ")}, `}
                              {row.state_ids?.length > 0 && `${row.state_ids.map(s => `${s.state_name}(S)`).join(", ")}, `}
                              {row.district_ids?.length > 0 && `${row.district_ids.map(d => `${d.dist_name}(D)`).join(", ")}, `}
                              {row.constituency_ids?.length > 0 && `${row.constituency_ids.map(c => `${c.const_name}(C)`).join(", ")}, `}
                              {row.mandal_ids?.length > 0 && `${row.mandal_ids.map(m => `${m.mandal_name}(M)`).join(", ")}, `}
                              {row.village_ids?.length > 0 && `${row.village_ids.map(v => `${v.village}(V)`).join(", ")}, `}
                            </td>
                            <td>{row?.sales_region_location}</td>
                            <td>{row?.order_id}</td>
                            <td>{row?.order_name}</td>
                            <td>{row?.company_name || "-"}</td>
                            <td>{row?.sales_person_name}</td>
                            <td>
                              {Array.isArray(row.brands) && row.brands.length > 0 ? (
                                <div>{row.brands.join(", ")}</div>
                              ) : '-'}
                            </td>
                            <td>{row.isnew ? `NEW` :`OLD`}</td>
                            <td>{row?.ispackage === 1 ? `TRUE` : `FALSE`}</td>
                            <td>{formatAgency(row)}</td>
                            <td onClick={(e) => e.stopPropagation()}>
                              {getRoFileUrl(row) ? (
                                <div className="d-flex gap-3">
                                  <sl-tooltip content="View RO">
                                    <sl-icon-button
                                      library="lucide"
                                      name="view"
                                      onClick={() => {
                                        setViewPdf(true);
                                        setPdfUrl(getRoFileUrl(row));
                                      }}
                                    ></sl-icon-button>
                                  </sl-tooltip>
                                  <sl-tooltip content="Download RO">
                                    <sl-icon-button
                                      library="lucide"
                                      name="download"
                                      onClick={() => {
                                        downloadPdf(getRoFileUrl(row), row?.order_name);
                                      }}
                                    ></sl-icon-button>
                                  </sl-tooltip>
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{formatDateDDMMYYY(row?.o_start_date)}</td>
                            <td title={row?.order_value ?? 0}>{formatSpentValue(row?.order_value)}</td>
                            <td title={getOrderValueWithGst(row?.order_value)}>{formatSpentValue(getOrderValueWithGst(row?.order_value))}</td>
                            <td title={row?.total_paid ?? 0}>{formatSpentValue(row?.total_paid)}</td>
                            <td title={getPendingAmount(row)}>{formatSpentValue(getPendingAmount(row))}</td>
                            <td title={row?.filterSpent ?? row?.filter_spent ?? 0}>
                              {formatSpentValue(row?.filterSpent ?? row?.filter_spent)}
                            </td>
                            <td title={row?.total_spent ?? 0}>
                              {formatSpentValue(row?.total_spent)}
                            </td>
                            <td>
                                <SlButton 
                                  variant="primary"
                                  size="small"
                                  className="px-3 py-1"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    viewPayments(row);
                                  }}
                                >
                                  View Payments
                                </SlButton>
                              </td>
                            </tr>
                            {internalDetails && internalDetails.order_id === row.order_id && (
                            <tr>
                              <td colSpan={TABLE_COLSPAN} className="p-4">
                                <div className="flex justify-center">
                                  <div className="border rounded-xl shadow-sm bg-white p-4 w-[80%] relative">
                                    <button
                                        onClick={() => setInternalDetails([])}
                                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                                      >
                                        ✕
                                      </button>
                                    <h3 className="text-lg font-semibold mb-3 text-gray-700 text-center">
                                      Campaign Details
                                    </h3>

                                    <table className="w-full border-collapse">
                                      <thead>
                                        <tr style={{ backgroundColor: "#dbeafe" }}>
                                          {" "}
                                          {/* Change theme here */}
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            S.No
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            Campaign Name
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            Campaign Type
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            Start Date
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            End Date
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {internalDetails.list.length > 0 ? (
                                          internalDetails.list.map((item, idx) => (
                                            <tr
                                              key={idx}
                                              style={{
                                                backgroundColor:
                                                  idx % 2 === 0 ? "#ffffff" : "#eff6ff",
                                                transition: "0.2s",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {idx + 1}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {item.campaign_name}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {item.campaign_type}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {formatDateDDMMYYY(item.start_date)}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {formatDateDDMMYYY(item.end_date)}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {item?.spent || 0}
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td
                                              className="border p-3 text-center text-gray-500"
                                              colSpan={6}
                                            >
                                              No data found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </td>
                            </tr>
                    )}
                        </>
                    ))}
                    <tr className="bg-blue-100 font-bold text-lg">
                        <td colSpan={15} className="text-center font-bold">Grand Total</td>

                        {/* Total Order Value */}
                        <td title={financedata.reduce(
                                (sum, row) => sum + Number(row?.order_value || 0),
                                0
                            )}>
                            {formatSpentValue(financedata.reduce(
                                (sum, row) => sum + Number(row?.order_value || 0),
                                0
                            ))}
                        </td>
                        <td title={financedata.reduce(
                                (sum, row) => sum + getOrderValueWithGst(row?.order_value),
                                0
                            )}>
                            {formatSpentValue(financedata.reduce(
                                (sum, row) => sum + getOrderValueWithGst(row?.order_value),
                                0
                            ))}
                        </td>
                        {/* Total Received */}
                        <td title={financedata.reduce(
                                (sum, row) => sum + Number(row?.total_paid || 0),
                                0
                            )}>
                            {formatSpentValue(financedata.reduce(
                                (sum, row) => sum + Number(row?.total_paid || 0),
                                0
                            ))}
                        </td>
                        {/* Pending Amount */}
                        <td title={financedata.reduce(
                                (sum, row) => sum + getPendingAmount(row),
                                0
                            )}>
                            {formatSpentValue(financedata.reduce(
                                (sum, row) => sum + getPendingAmount(row),
                                0
                            ))}
                        </td>
                        <td title={financedata.reduce(
                                (sum, row) => sum + Number(row?.filterSpent ?? row?.filter_spent ?? 0),
                                0
                            )}>
                            {formatSpentValue(financedata.reduce(
                                (sum, row) => sum + Number(row?.filterSpent ?? row?.filter_spent ?? 0),
                                0
                            ))}
                        </td>
                        <td title={financedata.reduce(
                                (sum, row) => sum + Number(row?.total_spent ?? 0),
                                0
                            )}>
                            {formatSpentValue(financedata.reduce(
                                (sum, row) => sum + Number(row?.total_spent ?? 0),
                                0
                            ))}
                        </td>
                        <td></td>
                    </tr>
                    </tbody>
                ) : !financedata?.length && !loading ? (
                    <NoDataFound colspan={TABLE_COLSPAN} />
                ) : (
                    <TableSkelton colspan={TABLE_COLSPAN} />
                )}
            </table>
          </ScrollContainer>
          <div className="flex justify-end">
            {Math.ceil(totalcount / config.PER_PAGE) > 1 && (
              <Paginator pageCount={Math.ceil(totalcount / config.PER_PAGE)} handlePageClick={handlePageChange} forcePage={currentPage} />
            )}
          </div>
          <SlDrawer
            label={selectedOrder?.order_name}
            open={openPaymentDrawer}
            onSlRequestClose={() => setOpenPaymentDrawer(false)}
            onSlAfterHide={() => setselectedOrder([])}
            style={{ "--size": "450px" }}
          >
            {/* BODY */}
            <div className="p-4 space-y-4">
              <h3>{selectedOrder?.order_id}</h3>

              {selectedOrder?.payment_details?.length ? (
                <>
                  {selectedOrder.payment_details.map((payment, index) => (
                    <div
                      key={index}
                      className="border border-gray-300 bg-gray-100 rounded-lg p-4 shadow-sm"
                    >
                      <h3 className="font-bold text-blue-600 mb-3 text-lg">
                        Payment #{index + 1}
                      </h3>

                      {fields
                        .filter(field => !field.showWhen || field.showWhen(payment))
                        .map(({ key, label }) => {
                          const value = payment?.[key];
                          const finalValue =
                            key === "amount"
                              ? `₹${value}`
                              : key === "payment_type"
                              ? orderPaymentTypes.find(
                                  item => +item.value === +value
                                )?.label || value
                              : value;

                          return (
                            <p key={key} className="text-sm mb-1">
                              <span className="font-semibold">{label}:</span>{" "}
                              {finalValue || "-"}
                            </p>
                          );
                        })}
                    </div>
                  ))}
                </>
              ) : (
                <p className="text-center text-gray-500 py-6">
                  No Payment Details Found
                </p>
              )}
            </div>

            {/* FOOTER */}
            <div
              slot="footer"
              className="flex items-center justify-between w-full"
            >
              <div className="font-semibold text-lg text-blue-700">
                Total Paid: ₹{
                  selectedOrder?.payment_details?.reduce(
                    (sum, p) => sum + Number(p.amount || 0),
                    0
                  )
                }
              </div>

              <SlButton
                variant="danger"
                onClick={() => setOpenPaymentDrawer(false)}
              >
                Close
              </SlButton>
            </div>
          </SlDrawer>
          <PdfViewer url={pdfUrl} show={viewPdf} setShow={setViewPdf} />
        </div>
    )
}
export default FinanceReport;
